module.exports = "\n<button \n  (click)=\"login()\"\n  class=\"btn btn-primary\">Login with Google</button>"


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/core/components/login/login.component.html
// module id = ../../../../../src/app/core/components/login/login.component.html
// module chunks = 1